<template>
  <div
    v-if="modelValue"
    class="cm-overlay"
    @click.self="close"
  >
    <div class="cm-modal" role="dialog" :aria-label="title" aria-modal="true">
      <div class="cm-header d-flex align-items-center justify-content-between">
        <h6 class="mb-0">{{ title }}</h6>
        <button class="cm-close" @click="close">&times;</button>
      </div>
      <div class="cm-body">
        <ContactFormFields v-model="localContact" />
        <div v-if="error" class="alert alert-warning py-1 mt-2 mb-0">{{ error }}</div>
        <p class="small text-muted mb-0 mt-2"><strong>Note:</strong> Email or Phone is required.</p>
      </div>
      <div class="cm-footer d-flex justify-content-end gap-2">
        <button class="btn btn-light btn-sm" @click="close">Cancel</button>
        <button class="btn btn-primary btn-sm" :disabled="loading" @click="submit">
          <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
          {{ submitLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from 'vue'
import ContactFormFields from './ContactFormFields.vue'

export default defineComponent({
  name: 'ContactModal',
  components: { ContactFormFields },
  props: {
    modelValue: { type: Boolean, default: false },
    contact: {
      type: Object,
      default: () => ({ name:'', email:'', phone_code:'+91', phone:'', username:'', id:null, contact_id:null })
    },
    error: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    title: { type: String, default: 'Add Contact' },
    submitLabel: { type: String, default: 'Save' }
  },
  emits: ['update:modelValue', 'submit', 'cancel'],
  setup(props, { emit }) {
    const localContact = reactive({ ...props.contact })

    watch(
      () => props.contact,
      v => Object.assign(localContact, v || {}),
      { deep: true }
    )

    const close = () => {
      emit('update:modelValue', false)
      emit('cancel')
    }
    const submit = () => emit('submit', { ...localContact })

    return { localContact, close, submit }
  }
})
</script>

<style scoped>
.cm-overlay{ position: fixed; inset: 0; background: rgba(0,0,0,.55); display: flex; align-items: center; justify-content: center; z-index: 1060; }
.cm-modal{ width: 100%; max-width: 560px; background: #fff; border-radius: 14px; box-shadow: 0 18px 45px rgba(0,0,0,.22); position: relative; }
.cm-header,.cm-footer{ padding: .75rem 1rem; background: #f8f9fa; }
.cm-body{ padding: 1rem; }
.cm-close{ border: 0; background: transparent; font-size: 1.25rem; line-height: 1; }
.gap-2{ gap: .5rem; }
</style>
